import styles from './AchievedCorrection.module.css';

import { Fragment, useState } from 'react';

import { Modal } from '../common/Modal';

/**
 * Component to display the images that can be used for alignment validation.
 */
interface AlignmentValidationProps {
  validationSignedUrl: string;
};

const AlignmentValidation = ({ validationSignedUrl } : AlignmentValidationProps):
  React.JSX.Element => {

  const [validationToggled, setValidationToggled] = useState<boolean>(false);

  return (
    <Fragment>
      {(
        <div className={`${styles['validation-action-container']}`}>
          <div className={styles['validation-action-text']}>
            <div className={styles['validation-action-header']}>
              Post Op CT Measurement Validation Images
            </div>
            <div className="flex flex-col font-['Segoe_UI',sans-serif] font-normal justify-center relative shrink-0 text-medium-emphasis-font w-full">
              <p className="leading-[normal] text--text-h4">
                Want to review where measurement’s are calculated from post op? View them here.
              </p>
            </div>
          </div>
          <div>
            <button
              data-testid="toggle-validation-button"
              className={styles['validation-action-button']}
              onClick={() => setValidationToggled(true)}
            >
              View
            </button>
          </div>
        </div>
      )}

      { validationToggled && (
        <Modal
          title="Validation Image"
          onClose={() => setValidationToggled(false)}
        >
          <div className="maxxed-element">
            <img
              src={validationSignedUrl || ''}
              alt="Validation View"
              style={{
                maxHeight: '100%',
                width: 'auto',
                display: 'block',
                margin: '0 auto'
              }}
            />
          </div>
        </Modal>
      )}
    </Fragment>
  );
};

export default AlignmentValidation;
